export const AssignmentStatus = {
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  DISMISSED: 'dismissed',
  CANCELED: 'canceled',
};

export const FilterStatus = {
  [AssignmentStatus.INCOMPLETE]: 'Incomplete',
  [AssignmentStatus.COMPLETE]: 'Complete',
  [AssignmentStatus.DISMISSED]: 'Dismissed',
  [AssignmentStatus.CANCELED]: 'Canceled',
};

export const allStatuses = Object.keys(FilterStatus);
